<template>
  <div class="log">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        库存记录
        <div @click="getting()" class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px">刷新</div>
        </div>
      </div>
    </div>
    <div v-if="role" class="body">
      <div class="form-title">
        <div style="padding-left:10px">筛选查询</div>
      </div>
      <div style="background-color:white" class="search-box">
        <el-row class="search" :gutter="10">
          <el-col :span="3">
            <div class="label">供应商名称:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="from" clearable size="small" placeholder="供应商名称"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">商品名称:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="name" clearable size="small" placeholder="商品名称"></el-input>
          </el-col>
          <el-col :span="1.5">
            <div class="label">货号:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="item_no" clearable size="small" placeholder="货号"></el-input>
          </el-col>
          <el-col :span="4" align="center">
            <div class="search_button" @click="getting()">搜索</div>
          </el-col>
        </el-row>
      </div>
      <div style="background-color:white;margin-top:19px">
        <div class="table-top-border">
          <div class="table-top-title">
            <div class="table-top-left">
              <div>
                <i class="fas fa-bars"></i>
              </div>
              <div>数据列表</div>
            </div>
          </div>
        </div>
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="id" label="编号" width="60"></el-table-column>
          <el-table-column prop="name" label="商品名称"></el-table-column>
          <el-table-column prop="item_no" label="商品货号"></el-table-column>
          <el-table-column prop="brand" label="品牌"></el-table-column>
          <el-table-column prop="from" label="供应商"></el-table-column>
          <el-table-column prop="price" label="价格"></el-table-column>
          <el-table-column prop="number" label="数量"></el-table-column>
          <el-table-column prop="create_date" label="日期"></el-table-column>
          <el-table-column prop="create_member" label="操作者"></el-table-column>
          <el-table-column prop="remark" show-overflow-tooltip label="备注"></el-table-column>
        </el-table>
        <div class="pager">
          <el-row>
            <el-col :span="50">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="15"
                @current-change="setPage"
              >1</el-pagination>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <noAccess v-else></noAccess>
  </div>
</template>

<script>
export default {
  name: 'inventoryList',
  data() {
    return { serve: this.$store.state.serve,
    role:true,
      username: this.$cookies.get('username'),
      token: this.$cookies.get('token'),
      serve: this.$store.state.serve,
      id: this.$route.params.id,
      formLabelWidth: '100px',
      tableData: [],
      from: '',
      time: '',
      resType: 0,
      type: null,
      total: 0,
      page: 1,
      name: '',
      item_no: ''
    }
  },
  created() {
    this.$store.state.topActiveId = 8
    this.$store.state.leftTitle = '入库记录'
    this.getting()
  },
  methods: {
    setType(e) {
      if (e == 1) {
        this.type = 0
      } else if (e == 2) {
        this.type = 1
      } else {
        this.type = null
      }
      this.resType = e
      this.getting()
    },
    filterTag(value, row) {
      return row.tag === value
    },
    setPage(v) {
      //分页

      this.page = v
      this.getting(v)
    },
    getting(page) {
      const loading = this.$loading({
        lock: true,
        text: '正在加载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var where = {}
      where.username = this.username
      where.token = this.token
      where.type = 0
      where.page = page
      where.from = this.from
      where.name = this.name
      where.item_no = this.item_no
      this.axios
        .get(this.serve + '/admin/log_inventory2', {
          params: where
        })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            var res = data.data.results
            this.total = data.data.total
            this.page = data.data.page
            for (let i in res) {
              var timeNew = new Date(parseInt(res[i].create_date) * 1000)
                .toLocaleString()
                .replace(/:\d{1,2}$/, ' ')
              res[i].create_date = timeNew
            }
            this.tableData = data.data.results
          } else {
            if(data.msg == "无权访问"){
              this.role = false
            }
            this.tableData = []
          }
          loading.close()
        })
    },
    exit_inventory() {
      var form = this.formExit
      if (form.number > 0) {
      } else {
        this.$message({
          showClose: true,
          message: '数量必须大于0!',
          type: 'error',
          offset: 200
        })
        return
      }
      if (form.to == '') {
        this.$message({
          showClose: true,
          message: '客户名称不能为空!',
          type: 'error',
          offset: 200
        })
        return
      }
      this.showExit = !this.showExit
      form.fid = this.id
      form.username = this.username
      form.token = this.token
      this.axios
        .get(this.serve + '/admin/exit_inventory', {
          params: form
        })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.$message({
              showClose: true,
              message: '出库成功!',
              type: 'success',
              offset: 200
            })
          } else {
            this.$message({
              showClose: true,
              message: '出库失败!',
              type: 'error',
              offset: 200
            })
          }
          this.getting()
          this.formExit = {}
        })
    },
    enter_inventory() {
      var form = this.form
      if (form.number > 0 || form.price > 0) {
      } else {
        this.$message({
          showClose: true,
          message: '价格和数量必须大于0!',
          type: 'error',
          offset: 200
        })
        return
      }
      this.showEnter = !this.showEnter
      form.fid = this.id
      form.username = this.username
      form.token = this.token
      this.axios
        .get(this.serve + '/admin/enter_inventory', {
          params: form
        })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.$message({
              showClose: true,
              message: '入库成功!',
              type: 'success',
              offset: 200
            })
          } else {
            this.$message({
              showClose: true,
              message: '入库失败!',
              type: 'error',
              offset: 200
            })
          }
          this.form = {}
          this.getting()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.log {
  .search-box {
    width: 1054px;
    height: 86px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
  }
  color: #333;
  min-height: 1000px;
  padding-bottom: 100px;
  background: #f5f5f5;
  .pager {
    display: flex;
    justify-content: center;
  }
  .addSupplier {
    margin-right: 20px;
  }
  .addSupplier:hover {
    color: white;
    background-color: #0099ff;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .search .el-col {
    line-height: 80px;
  }
  .search_button {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: 'MicrosoftYaHeiLight';
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .search_button:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .menu1 {
    display: flex;
    margin-bottom: 20px;
    .btn3 {
      margin-right: 0;
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
    .active i {
      color: #fff;
    }
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .form-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .body {
    width: 1056px;
    margin: 0 auto;
    .table-top-title {
      background-color: #eee;
      width: 100%;
      height: 46px;
      display: flex;
      justify-content: space-between;
    }
    .table-top-left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .table-top-border {
      border: 1px solid rgba(221, 221, 221, 1);
    }
    .search {
      display: flex;
      justify-content: left;
      .el-col {
        line-height: 80px;
      }
    }
  }
}
</style>